import React from 'react';

const ErrorDisplay = ({ errorMessage, onClose }) => {
    if (!errorMessage) return null;

    return (
        <div className="bg-white/50 text-red-500 my-4 rounded-md px-4 py-2 shadow-lg flex items-center w-full">
            <p className="mr-4">{errorMessage}</p>
            <button
                onClick={onClose}
                className="text-red-500 hover:text-red-700 focus:outline-none"
            >
                ✕
            </button>
        </div>
    );
};

export default ErrorDisplay;
